import React from 'react';
import { Button, Tooltip, Tag, Badge, Table } from 'antd';
import global from '../../../common/utility/global';


const HOY = 0;
const VENCIDOS = 1;
const PORVENCER = 2;

export default function GeneralTable(props) {



    const renderColor = (row) => {
        if (row.codigoEstado == VENCIDOS)
            return 'red';
        if (row.codigoEstado == PORVENCER)
            return '#52c41a';
        if (row.codigoEstado == HOY)
            return 'blue';
    };
    return (
        <Table
            className="table-general"
            dataSource={props.pagination.data}
            scroll={{ x: true }}
            size="small"
            style={{ overflowX: "auto" }}
            onChange={(pagination, filters, sorter) => {
                props.onChange({
                    page: pagination.current,
                    order: sorter.order,
                    field: sorter.field
                })
            }}
            pagination={{
                total: props.pagination.total,
                current: props.pagination.page,
                pageSize: props.pagination.pageSize,
                showTotal: (total) => `${total} Registro(s) encontrado(s).`
            }}
            rowKey={(record) => record.uid}
            title={() => (
                <div style={{ width: "100%", textAlign: "right" }}>
                    <div className="custom-options">
                        {props.onExportExcel === undefined ? null : (
                            <Button
                                ghost
                                type="success"
                                icon="file-excel"
                                onClick={props.onExportExcel}
                                style={{ color: "#3fb703" }}
                                loading={props.loadingExcel}
                            >
                                Excel
                            </Button>
                        )}
                    </div>
                </div>
            )}
            columns={[
                {
                    title: 'Código de Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    sorter: true
                },

                {
                    title: 'Producto',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Unidad de Medida',
                    dataIndex: 'nombreUnidadMedida',
                    key: 'nombreUnidadMedida',
                    sorter: true
                },
                {
                    title: 'Categoria',
                    dataIndex: 'categoria',
                    key: 'categoria',
                    sorter: true
                },
                {
                    title: 'Lote',
                    dataIndex: 'lote',
                    key: 'lote',
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencimiento',
                    key: 'fechaVencimiento',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'estadoVencimiento',
                    key: 'estadoVencimiento',
                    sorter: true,
                    align: 'center',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                },

            ]}
        />
    );

}

